import escapeRegExp from "lodash/escapeRegExp";

export const MAX_DISPLAYED_OPTIONS = 500;

export const filterAndSlice = (options, inputValue) => {
  if (!inputValue) {
    return [...options]
      .sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()))
      .slice(0, MAX_DISPLAYED_OPTIONS);
  }

  const matchByStart = [];
  const matchByInclusion = [];
  const regByInclusion = new RegExp(escapeRegExp(inputValue), "i");
  const regByStart = new RegExp(`^${escapeRegExp(inputValue)}`, "i");

  for (const option of options) {
    if (regByInclusion.test(option.label)) {
      if (regByStart.test(option.label)) {
        matchByStart.push(option);
      } else {
        matchByInclusion.push(option);
      }
    }
  }

  return [...matchByStart, ...matchByInclusion].slice(0, MAX_DISPLAYED_OPTIONS);
};
